"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * PlumbingWorld-3.0
 * PlumbingWorld API
 *
 * Contact: jspencer@juliusspencer.co.nz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateOrderToJSON = exports.CreateOrderFromJSONTyped = exports.CreateOrderFromJSON = exports.CreateOrderCheckoutMethodEnum = exports.CreateOrderDespatchMethodEnum = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
/**
* @export
* @enum {string}
*/
var CreateOrderDespatchMethodEnum;
(function (CreateOrderDespatchMethodEnum) {
    CreateOrderDespatchMethodEnum["CPU"] = "CPU";
    CreateOrderDespatchMethodEnum["DIR_D"] = "Dir-D";
    CreateOrderDespatchMethodEnum["IN_STORE"] = "In-Store";
})(CreateOrderDespatchMethodEnum = exports.CreateOrderDespatchMethodEnum || (exports.CreateOrderDespatchMethodEnum = {})); /**
* @export
* @enum {string}
*/
var CreateOrderCheckoutMethodEnum;
(function (CreateOrderCheckoutMethodEnum) {
    CreateOrderCheckoutMethodEnum["STOCK_SIMPRO"] = "STOCK_SIMPRO";
    CreateOrderCheckoutMethodEnum["JOB_SIMPRO"] = "JOB_SIMPRO";
})(CreateOrderCheckoutMethodEnum = exports.CreateOrderCheckoutMethodEnum || (exports.CreateOrderCheckoutMethodEnum = {}));
function CreateOrderFromJSON(json) {
    return CreateOrderFromJSONTyped(json, false);
}
exports.CreateOrderFromJSON = CreateOrderFromJSON;
function CreateOrderFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'orderReference': !runtime_1.exists(json, 'orderReference') ? undefined : json['orderReference'],
        'builderContact': !runtime_1.exists(json, 'builderContact') ? undefined : json['builderContact'],
        'customerId': json['customerId'],
        'orderItems': !runtime_1.exists(json, 'orderItems') ? undefined : (json['orderItems'].map(_1.OrderItemFromJSON)),
        'branchId': json['branchId'],
        'clientName': !runtime_1.exists(json, 'clientName') ? undefined : json['clientName'],
        'clientAddress': !runtime_1.exists(json, 'clientAddress') ? undefined : json['clientAddress'],
        'clientCity': !runtime_1.exists(json, 'clientCity') ? undefined : json['clientCity'],
        'clientSuburb': !runtime_1.exists(json, 'clientSuburb') ? undefined : json['clientSuburb'],
        'despatchMethod': json['despatchMethod'],
        'despatchSlot': !runtime_1.exists(json, 'despatchSlot') ? undefined : json['despatchSlot'],
        'shippingInstructions': !runtime_1.exists(json, 'shippingInstructions') ? undefined : json['shippingInstructions'],
        'notes': !runtime_1.exists(json, 'notes') ? undefined : json['notes'],
        'dateRequired': !runtime_1.exists(json, 'dateRequired') ? undefined : json['dateRequired'],
        'userId': !runtime_1.exists(json, 'userId') ? undefined : json['userId'],
        'userEmail': !runtime_1.exists(json, 'userEmail') ? undefined : json['userEmail'],
        'checkoutMethod': !runtime_1.exists(json, 'checkoutMethod') ? undefined : json['checkoutMethod'],
        'integrationData': !runtime_1.exists(json, 'integrationData') ? undefined : (json['integrationData'].map(_1.IntegrationDataFromJSON)),
        'externalReference': !runtime_1.exists(json, 'externalReference') ? undefined : json['externalReference'],
        'serviceItems': !runtime_1.exists(json, 'serviceItems') ? undefined : (json['serviceItems'].map(_1.OrderServiceItemFromJSON)),
        'jobContractId': !runtime_1.exists(json, 'jobContractId') ? undefined : json['jobContractId'],
        'interimOrder': !runtime_1.exists(json, 'interimOrder') ? undefined : json['interimOrder'],
        'cashSale': !runtime_1.exists(json, 'cashSale') ? undefined : json['cashSale'],
        'printLayout': !runtime_1.exists(json, 'printLayout') ? undefined : _1.PrintLayoutFromJSON(json['printLayout']),
        'cashPayments': !runtime_1.exists(json, 'cashPayments') ? undefined : (json['cashPayments'].map(_1.CashPaymentFromJSON)),
    };
}
exports.CreateOrderFromJSONTyped = CreateOrderFromJSONTyped;
function CreateOrderToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'orderReference': value.orderReference,
        'builderContact': value.builderContact,
        'customerId': value.customerId,
        'orderItems': value.orderItems === undefined ? undefined : (value.orderItems.map(_1.OrderItemToJSON)),
        'branchId': value.branchId,
        'clientName': value.clientName,
        'clientAddress': value.clientAddress,
        'clientCity': value.clientCity,
        'clientSuburb': value.clientSuburb,
        'despatchMethod': value.despatchMethod,
        'despatchSlot': value.despatchSlot,
        'shippingInstructions': value.shippingInstructions,
        'notes': value.notes,
        'dateRequired': value.dateRequired,
        'userId': value.userId,
        'userEmail': value.userEmail,
        'checkoutMethod': value.checkoutMethod,
        'integrationData': value.integrationData === undefined ? undefined : (value.integrationData.map(_1.IntegrationDataToJSON)),
        'externalReference': value.externalReference,
        'serviceItems': value.serviceItems === undefined ? undefined : (value.serviceItems.map(_1.OrderServiceItemToJSON)),
        'jobContractId': value.jobContractId,
        'interimOrder': value.interimOrder,
        'cashSale': value.cashSale,
        'printLayout': _1.PrintLayoutToJSON(value.printLayout),
        'cashPayments': value.cashPayments === undefined ? undefined : (value.cashPayments.map(_1.CashPaymentToJSON)),
    };
}
exports.CreateOrderToJSON = CreateOrderToJSON;
